import { InjectionToken, Provider, Type } from '@angular/core';
import { DataService, ScrollService } from 'lu-services';
import { LuTypeaheadChipLabelOptions } from './lu-typeahead-chip-label/lu-typeahead-chip-label.component';
import { LuTypeaheadItemTitleLabelOptions } from './lu-typeahead-item-title-label/lu-typeahead-item-title-label.component';
import { LuTypeaheadCustomItem } from './lu-typeahead-items/lu-typeahead-custom-item';
import { LuTypeaheadService } from './lu-typeahead.service';

export const dataService = new InjectionToken<DataService>('dataService');
export const scrollService = new InjectionToken<ScrollService>('scrollService');

export interface LuTypeaheadModuleConfig {
	dataService?: Provider;
	scrollService?: Provider;
}

export interface LuTypeaheadSelectAll {
	value: number | string;
	label: string;
	singleChip: boolean;
}

export interface LuTypeaheadOptions {
	items?: any[];
	itemOptions: LuTypeaheadCustomItemOptions | LuTypeaheadItemTitleLabelOptions;
	chipOptions: LuTypeaheadCustomChipOptions | LuTypeaheadChipLabelOptions;
	paginate?: boolean;
	searchPlaceholder?: string;
	maxSelections?: number;
	alwaysOpen?: boolean;
	isAbsolute?: boolean;
	selectAs?: string;
	filterBy: string;
	initFocus?: boolean;
	disabled?: boolean;
	readonly?: boolean;
	hideChips?: boolean;
	customExclude?: boolean; // we want to pass exclude as custom thorugh url options params
	selectAll?: Partial<LuTypeaheadSelectAll>;
	id?: string;
	isScrollable?: boolean;
	isMultiselectView?: boolean;
	showFooterActions?: boolean;
	showFilterClear?: boolean;
	insightsService?: any;
	trackingString?: string;
}

export interface LuTypeaheadUrlOptions {
	apiUrl?: string;
	params?: {
		[name: string]: string | string[] | boolean | boolean[] | number | number[];
	};
}

export abstract class LuBaseTypeahedBaseOptions {
	abstract type: LuTypeaheadType;
}

export class LuTypeaheadCustomChipOptions extends LuBaseTypeahedBaseOptions {
	itemComponent: Type<any>;
	interface: any;
	type: LuTypeaheadType.CUSTOM;
}

export interface ILuTypeaheadCustomItem {
	dummy?: string;
}

export interface ILuTypeaheadCustomChip {
	dummy?: string;
}

export class LuTypeaheadCustomItemOptions {
	itemComponent: Type<LuTypeaheadCustomItem<ILuTypeaheadCustomItem>>;
	interface: ILuTypeaheadCustomItem;
	type: LuTypeaheadType.CUSTOM;
}

export interface LuTypeaheadInstance {
	service: LuTypeaheadService;
}

export enum LuTypeaheadType {
	PRIMARY_SECONDARY = 'primary-secondary',
	CUSTOM = 'custom'
}
